import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  titleValidation: {
    color: theme?.palette?.inputValidation?.main,
    marginTop: '4px',
    marginBottom: '0px',
    fontSize: '12px',
  },
  arrow: {
    '&::before': {
      backgroundColor: 'rgb(0 0 0 / 60%)',
    },
  },
  tooltip: {
    backgroundColor: 'rgb(0 0 0 / 60%)',
    color: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
  dialogTitle: {
    fontSize: '20px',
    fontWeight: 500,
  },
  editButton: {
    background: 'rgba(0, 0, 0, 0)',

    border: `1px solid ${theme?.palette?.primaryButton?.main}`,
    color: theme?.palette?.primaryButton?.main,
    lineHeight: '14px',
    marginLeft: '12px',
    padding: '4px 0px',
    '&:hover': {
      color: '#FFFFFF',
      background: theme?.palette?.primaryButton?.main,
    },
  },
  titleHeader: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'space-between',
  },
  titleLength: {
    color: '#7a7878',
  },
}))
export { styles }
